@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  <div
    [ngClass]="{ error: error, edit: editMode, 'side-panel': sidePanel }"
    class="email-edit-wrapper"
    data-test-id="email-edit-container"
  >
    @if (!editMode && !sidePanel) {
      <div>
        <div class="email-edit-values">
          <span [ngClass]="{ empty: !email }" class="email-label subheading">Email</span>
        </div>
        <div class="flex flex-between-stretch">
          <span [ngClass]="{ placeholder: !email }" class="email-value email" data-test-id="email-edit-email-value">
            {{ email || 'e.g. example@email.com' }}
          </span>
          @if (!readonly && canEdit) {
            <button
              (click)="activate()"
              class="small-button"
              color="primary"
              data-test-id="email-edit-email-add-edit-button"
              mat-button
            >
              {{ email ? 'Edit' : 'Add' }}
            </button>
          }
        </div>
      </div>
    }

    @if (!editMode && sidePanel) {
      <div class="flex flex-col flex-start-stretch">
        <div class="email-row row-border first-row flex flex-start-stretch">
          <div class="flex-data-wrapper">
            <div class="email-label-container">
              <span [ngClass]="{ empty: !email }" class="email-label">Email</span>
            </div>
            <div class="email-value-container">
              @if (email) {
                <a
                  [href]="'mailto:' + email?.trim()"
                  class="email-value"
                  data-test-id="email-edit-sidepanel-email-value"
                >
                  {{ email }}
                </a>
              }
              @if (!email && !readonly) {
                <span class="email-value email placeholder">e.g. example@email.com</span>
              }
            </div>
          </div>
          <div class="actions">
            @if (!readonly && canEdit) {
              <button
                (click)="activate()"
                class="small-button"
                color="primary"
                data-test-id="email-edit-sidepanel-email-add-edit-button"
                mat-button
              >
                {{ email ? 'Edit' : 'Add' }}
              </button>
            }
          </div>
        </div>
      </div>
    }

    @if (editMode) {
      <div class="email-edit-form-groups">
        <form
          [formGroup]="emailEditForm"
          [ngClass]="{ loading: loading }"
          (keydown)="keyListener($event)"
          (keypress)="keyListener($event)"
          (ngSubmit)="update()"
          class="edit-form"
          data-test-id="email-edit-form"
          name="emailEditForm"
        >
          <h4 class="font-bold">Edit email address</h4>
          <div class="content">
            <div class="my-12 text-14">
              Email is used as a login to the My7N Platform. Without access to it consultant won't be able to use 7N
              services and benefits.
            </div>
            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
              <mat-label>Email</mat-label>
              <input
                [maxlength]="MAX_EMAIL_LENGTH"
                data-test-id="email-edit-form-email-input"
                formControlName="email"
                matInput
                name="email"
                placeholder="Email"
                type="email"
              />
            </mat-form-field>
            <validation-messages
              [field]="emailEditForm.get('email')"
              [messages]="ERRORS.requestEmailUpdate.errors"
              [texts]="ERRORS.requestEmailUpdate.messages"
              class="error"
            ></validation-messages>
          </div>
          <div class="form-actions">
            <button
              [loading]="loading"
              class="small-button"
              color="primary"
              data-test-id="email-edit-form-save-button"
              mat-stroked-button
              type="submit"
            >
              {{
                breakpoints.ltMd ? COMMON_BUTTONS_TEXTS.SAVE_CHANGES_MOBILE : COMMON_BUTTONS_TEXTS.SAVE_CHANGES_DESKTOP
              }}
            </button>
            <button
              (click)="reset()"
              class="small-button cancel-button"
              color="primary"
              data-test-id="email-edit-form-discard-button"
              mat-button
              type="button"
            >
              {{
                breakpoints.ltMd
                  ? COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_MOBILE
                  : COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_DESKTOP
              }}
            </button>
          </div>
        </form>
      </div>
    }
  </div>
}
